import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  formControl: {
    width: '400px',
    marginRight: '1rem',
  },
}));
